import { Fragment } from 'react';

import { OwnerAvatar } from '@playbooks/components/owner/owner-avatar';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

export const CollectionCardActions = ({ layout = 'display', collection, actions = null }) => {
	const props = { collection, actions };

	switch (layout) {
		case 'display':
			return <CollectionDisplayCardActions {...props} />;

		case 'list':
			return <CollectionListCardActions {...props} />;

		case 'photo':
			return <CollectionPhotoCardActions {...props} />;

		case 'preview':
			return <CollectionPreviewCardActions {...props} />;
	}
};

export const CollectionDisplayCardActions = ({ collection }) => (
	<Fragment>
		<OwnerAvatar layout='meta' owner={collection.owner} href={collection.owner?.appPath || ''} />
	</Fragment>
);

export const CollectionListCardActions = ({ collection }) => (
	<Fragment>
		<OwnerAvatar layout='meta' owner={collection.owner} href={collection.owner?.appPath || ''} />
	</Fragment>
);

export const CollectionPhotoCardActions = ({ collection }) => (
	<Fragment>
		<OwnerAvatar layout='meta' owner={collection.owner} href={collection.owner?.appPath || ''} />
	</Fragment>
);

export const CollectionPreviewCardActions = ({ collection, actions }) => {
	const { onClick, onDelete, deleteTask } = actions;
	return (
		<Fragment>
			<Button
				variant='outline'
				size='icon'
				isLoading={deleteTask.id === collection.id && deleteTask.running}
				onClick={() => onDelete(collection)}
				className='text-danger'>
				<Icon data-icon='inline-start' type='far' icon='trash' aria-hidden />
			</Button>
			<Button variant='outline' size='icon' onClick={() => onClick(collection)}>
				<Icon data-icon='inline-start' type='far' icon='pencil' aria-hidden />
			</Button>
		</Fragment>
	);
};
